/**
 * Product Tabs Component
 * Handles tab switching and table row expansion functionality
 */
class ProductTabs {
    constructor() {
        this.init();
    }

    init() {
        this.setupTabSwitching();
        this.setupTableExpansion();
    }

    /**
     * Setup tab switching functionality
     */
    setupTabSwitching() {
        const tabs = document.querySelectorAll(".product-tabs__tab");

        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                const targetPanelId = tab.getAttribute("aria-controls");
                this.switchTab(tab, targetPanelId);
            });
        });
    }

    /**
     * Switch to the specified tab
     * @param {HTMLElement} activeTab - The tab to activate
     * @param {string} targetPanelId - The ID of the panel to show
     */
    switchTab(activeTab, targetPanelId) {
        // Remove active state from all tabs
        document.querySelectorAll(".product-tabs__tab").forEach((tab) => {
            tab.classList.remove("product-tabs__tab--active");
            tab.setAttribute("aria-selected", "false");
        });

        // Remove active state from all panels
        document.querySelectorAll(".product-tabs__panel").forEach((panel) => {
            panel.classList.remove("product-tabs__panel--active");
        });

        // Activate the clicked tab
        activeTab.classList.add("product-tabs__tab--active");
        activeTab.setAttribute("aria-selected", "true");

        // Show the corresponding panel
        const targetPanel = document.getElementById(targetPanelId);
        if (targetPanel) {
            targetPanel.classList.add("product-tabs__panel--active");
        }
    }

    /**
     * Setup table row expansion functionality
     */
    setupTableExpansion() {
        // Update border styling for tables on load
        this.updateAllTableBorders();

        // Handle "Show More" button clicks
        document
            .querySelectorAll(".product-tabs__show-more")
            .forEach((button) => {
                const tableKey = button.getAttribute("data-table");
                const tbody = document.getElementById(`table-rows-${tableKey}`);

                if (!tbody) return;

                button.addEventListener("click", () => {
                    this.expandTable(tbody, button);
                });
            });
    }

    /**
     * Expand a table to show all hidden rows
     * @param {HTMLElement} tbody - The table body element
     * @param {HTMLElement} button - The show more button
     */
    expandTable(tbody, button) {
        const hiddenRows = tbody.querySelectorAll("tr.d-none");

        hiddenRows.forEach((row, index) => {
            // Set initial opacity for smooth transition
            row.style.transition = "opacity 0.4s cubic-bezier(.4,0,.2,1)";
            row.style.opacity = "0";
            row.classList.remove("d-none");

            // Animate opacity with slight delay for each row
            setTimeout(
                () => {
                    row.style.opacity = "1";
                },
                10 + index * 50,
            );
        });

        // Update table borders after expansion
        setTimeout(() => {
            this.updateTableBorders(tbody);
        }, 100);

        // Hide the button
        button.style.display = "none";
    }

    /**
     * Update border styling for the last visible row in a table
     * @param {HTMLElement} tbody - The table body element
     */
    updateTableBorders(tbody) {
        // Reset all borders
        tbody.querySelectorAll("tr:not(.d-none) td").forEach((td) => {
            td.style.borderBottom =
                "1px solid var(--color-sames-blue-light, #e5edf3)";
        });

        // Remove border from last visible row
        const visibleRows = tbody.querySelectorAll("tr:not(.d-none)");
        const lastVisibleRow = visibleRows[visibleRows.length - 1];

        if (lastVisibleRow) {
            lastVisibleRow.querySelectorAll("td").forEach((td) => {
                td.style.borderBottom = "none";
            });
        }
    }

    /**
     * Update borders for all tables on the page
     */
    updateAllTableBorders() {
        document
            .querySelectorAll(".product-tabs__table tbody")
            .forEach((tbody) => {
                this.updateTableBorders(tbody);
            });
    }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
    new ProductTabs();
});

export default ProductTabs;
